var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"icon":"feather icon-settings"}},[_c('div',{staticClass:"text-center previewed_action_holder",style:({ backgroundImage: 'url(' + _vm.$route.params.certificte_details.certificate_image_details.file.file_path + ')' }),domProps:{"innerHTML":_vm._s(_vm.$route.params.certificte_details.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }